/**
 * @flow
 * Created by neo on 02.06.17.
 */

import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { translate } from 'react-i18next';
import { Collapse, Button, Row, Col, Card, CardBody, FormGroup, Label, Input, Alert, CustomInput} from 'reactstrap';
import BookingRequest from '../Store/Booking/BookingRequest';
import Passenger from '../Store/Booking/Passenger';
import Settings from '../Store/Settings';
import DisplayToggle from '../Components/DisplayToggle';
import { TextField } from '../Components/Form/TextField';

type Props = {
  booking: BookingRequest,
  open: boolean,
  enabled?: boolean,
};

@observer
export class PassengerInfo extends Component {

  state: {
    collapse: boolean,
    passenger: boolean,
    disabledAt: null,
  };

  constructor(props: Props) {
    super(props);
    this.state = {
      passenger: true,
      freeSeats: Array(props.booking.passengers.length).fill(false),
    };
  }

  componentWillReceiveProps(nextProps: Props) {
    if (this.state.passenger) {
      this.setPassenger(nextProps.booking);
    }
  }

  toggleCollapse = () => {
    if (this.props.enabled) {
      this.props.onToggleCollapse && this.props.onToggleCollapse();
    }
  };

  togglePassenger = (index: number) => {
    if (index === 0) {
      const passenger = !this.state.passenger;
      if (passenger) {
        this.setPassenger(this.props.booking);
      } else {
        this.unsetPassenger(this.props.booking);
      }
      this.setState({ passenger });
    } else {
      this.setState(prevState => {
        const newFreeSeats = [...prevState.freeSeats];
        const currentState = !newFreeSeats[index];

        // If the current switch is turned ON, set all below it to ON
        if (currentState) {
          for (let i = index; i < newFreeSeats.length; i++) {
            newFreeSeats[i] = true; // Set to ON
            this.props.booking.passengers[i].free_seat = 1; // Update the booking model
          }
        } else {
          // If the current switch is turned OFF, set all above it to OFF
          for (let i = 0; i <= index; i++) {
            newFreeSeats[i] = false; // Set to OFF
            this.props.booking.passengers[i].free_seat = 0; // Update the booking model
          }
        }
        return { freeSeats: newFreeSeats };
      });
    }
  };

  setPassenger(booking: BookingRequest) {
    const passenger = booking.passengers[0];
    passenger.last_name = booking.last_name;
    passenger.first_name = booking.first_name;
  }

  unsetPassenger(booking: BookingRequest) {
    const passenger = booking.passengers[0];
    passenger.last_name = '';
    passenger.first_name = '';
  }

  getInsuranceLink = () => {
    const data = Settings.settings.get('tos_url');
    if (data) {
      return data;
    } else {
      const file = Settings.settings.get('tos_file');
      if (file) {
        return file.url;
      }
    }
  };

  getSafteyLink = () => {
    const data = Settings.settings.get('safety_url');
    if (data) {
      return data;
    } else {
      const file = Settings.settings.get('safety_file');
      if (file) {
        return file.url;
      }
    }
  };

  handleNumberChange = (e) => {
    let value = e.target.value.length ? parseInt(e.target.value) : e.target.value;

    console.log(e.target.name, e.target.value, value, isNaN(value));

    if (isNaN(value)) {
      value = '';
    }

    this.props.booking[e.target.name] = value;
  };

  render() {
    const { t, booking } = this.props;
    const insuranceLink = this.getInsuranceLink();
    const safteyLink = this.getSafteyLink();
    const { settings } = Settings;
    const { freeSeats, passenger } = this.state;

    return (
      <Card className='h-100'>

        <CardBody>
          <h2>2. {t('Passagiere')}</h2>
          <Row className='mb-3'>
            <Col>
              {booking.passengers.map((p: Passenger, i: number) => (
                <div>
                  <Row key={i} className='mb-3'>
                    <Col xs='12' lg='4'>
                      <FormGroup>
                        <TextField
                          type='text'
                          label={t('Name')}
                          disabled={(i === 0 && passenger) || freeSeats[i]}
                          value={p.last_name || ''}
                          onChange={(e) => p.last_name = e.target.value}
                          placeholder={`${t('Passenger')} ${i + 1}`}
                        />
                      </FormGroup>
                    </Col>
                    <Col xs='12' lg='4'>
                      <FormGroup>
                        <TextField
                          type='text'
                          label={t('Vorname')}
                          disabled={(i === 0 && passenger) || freeSeats[i]}
                          value={p.first_name || ''}
                          onChange={(e) => p.first_name = e.target.value}
                        />
                      </FormGroup>
                    </Col>
                    <Col xs='12' lg='4'>
                      <FormGroup>
                        <TextField
                          type='number'
                          disabled={freeSeats[i]}
                          label={t('Gewicht ({{unit}})', { unit: t(`unit.${settings.get('weight_unit')}`) })}
                          value={p.weight || ''}
                          onChange={(e) => p.weight = Number(e.target.value)}
                        />
                      </FormGroup>
                    </Col>
                    {i === 0 && (
                      <Col xs='12'>
                        <FormGroup check>
                          <Label check>
                            <Input type='checkbox' checked={this.state.passenger}
                                   onChange={() => this.togglePassenger(i)} />{' '}
                            {t('Ich bin auch ein Passagier')}
                          </Label>
                        </FormGroup>
                      </Col>
                    )}
                    {i !== 0 && booking.is_exclusive && (
                      <Col xs='12'>
                        <FormGroup>
                          <CustomInput
                            type="switch"
                            id={`free-seat-switch-${i}`}
                            label={t('Make seat available for public sale')}
                            checked={freeSeats[i]}
                            onChange={() => this.togglePassenger(i)}
                            disabled={i === 0 && !this.props.enabled}
                          />
                        </FormGroup>
                      </Col>
                    )}
                  </Row>
                  <div className='mb-3 separator'></div>
                </div>
              ))}
            </Col>

          </Row>

          {
            booking.flightOffer.is_transfer &&
            <Row>
              <Col xs={12} md={6} className='d-flex flex-column justify-content-end'>
                <FormGroup>
                  <Label>{t('Number of Carry-Ons (under 30 pounds)')}</Label>
                  <Input
                    type='text'
                    bsSize='sm'
                    name='carry_on_count'
                    value={booking.carry_on_count || ''}
                    onChange={this.handleNumberChange}
                  />
                </FormGroup>
              </Col>
              <Col xs={12} md={6} className='d-flex flex-column justify-content-end'>
                <FormGroup>
                  <Label>{t('Number of Suitcases (over 30 pounds)')}</Label>
                  <Input
                    type='text'
                    bsSize='sm'
                    name='suitcase_count'
                    value={booking.suitcase_count || ''}
                    onChange={this.handleNumberChange}
                  />
                </FormGroup>
              </Col>
            </Row>
          }
        </CardBody>
        <CardBody>
          <Row>
            <Col>
              <p>{t('Hiermit bestätige ich, dass alle Passagiere bis zum Abflug')}</p>
            </Col>
          </Row>
          <Row>
            <Col>
              <FormGroup check>
                <Label check>
                  <Input type='checkbox' checked={booking.check_insurance_info}
                         onClick={(e) => booking.check_insurance_info = e.target.checked} />{' '}
                  {t('acknowledged_intro')}
                  <a href={insuranceLink} target='_blank' rel='noopener noreferrer'>
                    {t('terms_and_conditions')}
                  </a>
                  {t('acknowledged_outro')}
                </Label>
              </FormGroup>
              <FormGroup check>
                <Label check>
                  <Input type='checkbox' checked={booking.check_safety_info}
                         onClick={(e) => booking.check_safety_info = e.target.checked} />{' '}
                  {t('safety_video_intro')}
                  <a href={safteyLink} target='_blank' rel='noopener noreferrer'>
                    {t('safety_video')}
                  </a>
                  {t('safety_video_outro')}
                </Label>
              </FormGroup>
            </Col>
          </Row>
        </CardBody>
        <CardBody>
          {
            (!booking.check_insurance_info || !booking.check_safety_info) &&
            <Alert color='danger'>
              {'*'} {t('You must agree to the terms and conditions')}
            </Alert>
          }
          <Alert color='info'>
            {t('Sie können bis 24 Stunden vor Abflug diese Passagierliste bearbeiten. Sie erhalten den Zugriff per E-Mail')}
          </Alert>
          <Alert color='warning'>
            {t('Anders als bei Linienflugzeugen, ist die Angabe des Gewichtes eines Passagier für Helikopterflüge sehr wichtig für Ihre Sicherheit.')}
          </Alert>
        </CardBody>
      </Card>
    )
      ;
  }
}

export default translate()(PassengerInfo);



// WEBPACK FOOTER //
// ./src/App/Booking/PassengerInfo.js